// extracted by mini-css-extract-plugin
export default {"containprod":"JC","containprod2":"KC","title":"LC","servings":"MC","recommendation":"NC","image":"OC","flavorswrap":"PC","flavorsgroupwrap":"QC","moredetailsWrap":"RC","infoWrap":"SC","price":"TC","regularPrice":"UC","netPrice":"VC","addtocartcontainer":"WC","error":"XC"};
    if(module.hot) {
      // 1714422956204
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  